module.exports = __webpack_public_path__ + "static/media/server-4.d7154d51.svg";